__turbopack_context__.v({
  "app_light_theme": "DiscountModal-module-scss-module__3V8x7a__app_light_theme",
  "button": "DiscountModal-module-scss-module__3V8x7a__button",
  "checkboxes": "DiscountModal-module-scss-module__3V8x7a__checkboxes",
  "error": "DiscountModal-module-scss-module__3V8x7a__error",
  "errorBlock": "DiscountModal-module-scss-module__3V8x7a__errorBlock",
  "errorContact": "DiscountModal-module-scss-module__3V8x7a__errorContact",
  "errorMessage": "DiscountModal-module-scss-module__3V8x7a__errorMessage",
  "form": "DiscountModal-module-scss-module__3V8x7a__form",
  "formButton": "DiscountModal-module-scss-module__3V8x7a__formButton",
  "formField": "DiscountModal-module-scss-module__3V8x7a__formField",
  "header": "DiscountModal-module-scss-module__3V8x7a__header",
  "image": "DiscountModal-module-scss-module__3V8x7a__image",
  "info": "DiscountModal-module-scss-module__3V8x7a__info",
  "itemTitle": "DiscountModal-module-scss-module__3V8x7a__itemTitle",
  "modal": "DiscountModal-module-scss-module__3V8x7a__modal",
  "price": "DiscountModal-module-scss-module__3V8x7a__price",
  "stock": "DiscountModal-module-scss-module__3V8x7a__stock",
  "title": "DiscountModal-module-scss-module__3V8x7a__title",
});
